// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__uXPuU","noInteraction":"EventWrapper_noInteraction__Z3lLk"};